var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { forwardRef, useState } from 'react';
import { ScrollView, View } from 'react-native';
import { Badge, getTestId, tokens } from '@airtel/air-design-system';
import { getWithDynamicBadgeStyles } from './WithDynamicBadgeStyles';
export var withDynamicBadge = Component => {
  var Wrapper = forwardRef(props => {
    var _a;
    var testID = props.testID,
      _props$withDynamicBad = props.withDynamicBadge,
      withDynamicBadge = _props$withDynamicBad === void 0 ? false : _props$withDynamicBad,
      _props$withDynamicBad2 = props.withDynamicBadgeData,
      withDynamicBadgeData = _props$withDynamicBad2 === void 0 ? [] : _props$withDynamicBad2,
      dynamicBadgeScrollViewProps = props.dynamicBadgeScrollViewProps,
      withDynamicBadgeContainerStyle = props.withDynamicBadgeContainerStyle,
      restProps = __rest(props, ["testID", "withDynamicBadge", "withDynamicBadgeData", "dynamicBadgeScrollViewProps", "withDynamicBadgeContainerStyle"]);
    var withDynamicBadgeStyles = getWithDynamicBadgeStyles();
    var _useState = useState(() => {
        var defaultSelectedIndex = withDynamicBadgeData.findIndex(item => {
          var _a;
          return (_a = item.badge) === null || _a === void 0 ? void 0 : _a.isSelected;
        });
        return withDynamicBadgeData.map((item, index) => Object.assign(Object.assign({}, item), {
          badge: Object.assign(Object.assign({}, item.badge), {
            isSelected: defaultSelectedIndex === -1 ? index === 0 : index === defaultSelectedIndex
          })
        }));
      }),
      data = _useState[0],
      setData = _useState[1];
    var selectedData = ((_a = data.find(item => {
      var _a;
      return (_a = item.badge) === null || _a === void 0 ? void 0 : _a.isSelected;
    })) === null || _a === void 0 ? void 0 : _a.componentProps) || null;
    var onBadgePressHandler = badgeIndex => {
      setData(prevData => prevData.map((plan, index) => Object.assign(Object.assign({}, plan), {
        badge: Object.assign(Object.assign({}, plan.badge), {
          isSelected: index === badgeIndex
        })
      })));
    };
    return _jsx(_Fragment, {
      children: withDynamicBadge && withDynamicBadgeData.length > 0 ? _jsxs(View, Object.assign({}, getTestId(testID, 'withDynamicBadge_container'), {
        style: [withDynamicBadgeStyles.container, withDynamicBadgeContainerStyle]
      }, {
        children: [_jsx(ScrollView, Object.assign({
          horizontal: true
        }, getTestId(testID, 'withDynamicBadge_scrollView'), {
          showsHorizontalScrollIndicator: false
        }, dynamicBadgeScrollViewProps, {
          children: data === null || data === void 0 ? void 0 : data.map((dataProps, index) => {
            var _a;
            return _jsx(View, Object.assign({
              style: [{
                marginRight: index === data.length - 1 ? 0 : tokens.spacing.SPACING_8
              }, (_a = dataProps === null || dataProps === void 0 ? void 0 : dataProps.componentProps) === null || _a === void 0 ? void 0 : _a.badgeContainerStyle]
            }, {
              children: _jsx(Badge, Object.assign({}, getTestId(testID, "withDynamicBadge_badge_" + index), dataProps.badge, {
                onPress: () => onBadgePressHandler(index)
              }))
            }), index);
          })
        })), _jsx(Component, Object.assign({}, getTestId(testID, 'withDynamicBadge_data'), selectedData, {
          onUserAction: restProps.onUserAction
        }))]
      })) : _jsx(Component, Object.assign({}, restProps))
    });
  });
  return Wrapper;
};